import React from "react";

// Card brand detection + display helpers
export const detectBrand = (num) => {
  const n = (num || "").replace(/\D/g, "");
  if (/^4/.test(n)) return "visa";
  if (/^(5[1-5]|2[2-7])/.test(n)) return "mastercard";
  if (/^3[47]/.test(n)) return "amex";
  if (/^6(?:011|5|4[4-9])/.test(n)) return "discover";
  return "";
};

const LABELS = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  discover: "Discover",
};

const COLORS = {
  visa: "#1A1F71",
  mastercard: "#EB001B",
  amex: "#2E77BC",
  discover: "#F58220",
  "": "#94A3B8",
};

export const BrandBadge = ({ brand, className = "" }) => {
  const b = brand || "";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] font-bold uppercase tracking-wide ${className}`}
      style={{ background: `${COLORS[b]}14`, color: COLORS[b] }}
      data-testid="card-brand-badge"
    >
      <span className="h-2 w-2 rounded-sm" style={{ background: COLORS[b] }} />
      {LABELS[b] || "Card"}
    </span>
  );
};
